export default __webpack_public_path__ + "static/media/fa-regular-400.1069ea55.woff";